import React, { useState, useEffect } from "react";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBtnWrap,
  SidebarRoute,
  SidebarDropdown,
} from "./SidebarElements";
import { withRouter, NavLink } from "react-router-dom";
import * as actionTypes from "../../store/actions";
import { connect } from "react-redux";
import axios from "../../axios";
import { DropdownMenu, DropdownItem, DropdownToggle, Dropdown, UncontrolledDropdown } from "reactstrap";
import { ProfileBox, ProfileImg } from "../../components/Navbar/LoginPopupElements";
import profileDemo from "../../images/profile/profile-icon.svg";
import { IoMdArrowDropdown } from "react-icons/io";
import { NavLinks } from "../Navbar/NavbarElements";

const Sidebar = ({ isOpen, toggle, setDefaultState, defaultState, userData, setUsers, history }) => {
  const [currentUser, setCurrentUser] = useState([]);

  useEffect(() => {
    currentUserFun();
  }, []);

  const currentUserFun = async () => {
    const { data } = await axios.get("/current-user");
    const { data: data2 } = await axios.get('/setting');
    const finalData = { ...data.data, settings: data2.data };
    setCurrentUser(finalData);
    localStorage.setItem("MenzilUserData", JSON.stringify(data.data));
    setUsers(finalData);
  };

  const handleLogout = () => {
    handleConfirm();
  };

  const handleConfirm = (async) => {
    if (window.confirm("Are you sure you want to Logout?")) {
      localStorage.removeItem("MenzilAccessToken");
      localStorage.removeItem("MenzilUserData");
      localStorage.removeItem("isMenzilUser");
      setUsers("");
      // setUsers("");
      history.push("/");
      history.go("0");
    }
  };

  // Approve: 1, inprogress: 2 , Disapprove: 3,
  const handleAgentStatus = async () => {
    if (currentUser?.is_approve === "1") {
      setDefaultState({
        isApproval: true,
      });
    } else if (currentUser?.is_approve === "2") {
      setDefaultState({
        isProcess: true,
      });
    } else if (currentUser?.is_approve === "3") {
      setDefaultState({
        isDisapprove: true,
      });

      // setDefaultState((prevState) => {
      //   return {
      //     ...prevState,
      //     isDisapprove: true,
      //   };
      // })
    }
  };

  return (
    <SidebarContainer isOpen={isOpen}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="/" onClick={() => toggle()}>
            Home
          </SidebarLink>
          {/* <SidebarLink to="/" onClick={() => toggle()}>
            Services
          </SidebarLink> */}
          <SidebarLink to="/" onClick={() => toggle()}>
            Properties
          </SidebarLink>
          <SidebarLink onClick={() => {if (userData) {
                history.push("/agent-finder");
              } else {
                setDefaultState({ isSignup: false, isLogin: true });
                toggle();
              }}}>
            Agent Finder
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          <SidebarRoute
            onClick={() => {
              if (userData) {
                history.push("/post-property");
              } else {
                setDefaultState({ isSignup: false, isLogin: true });
                toggle();
              }
            }}
          >
            Sell your Property
          </SidebarRoute>
          {!userData && (
            <SidebarRoute
              onClick={() => {
                setDefaultState({
                  isSignup: false,
                  isLogin: true,
                });
                toggle();
              }}
            >
              Sign in
            </SidebarRoute>
          )}
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
